import { render, staticRenderFns } from "./crudIvaConditions.vue?vue&type=template&id=20b4f0b4&"
import script from "./crudIvaConditions.vue?vue&type=script&lang=js&"
export * from "./crudIvaConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports